var map = {
	"./Companies/Edit": 359,
	"./Companies/Edit.js": 359,
	"./CreditCard/Edit": 243,
	"./CreditCard/Edit.js": 243,
	"./Dashboard/Company": 159,
	"./Dashboard/Company/": 159,
	"./Dashboard/Company/index": 159,
	"./Dashboard/Company/index.js": 159,
	"./Dashboard/Customer": 238,
	"./Dashboard/Customer/": 238,
	"./Dashboard/Customer/index": 238,
	"./Dashboard/Customer/index.js": 238,
	"./Dashboard/Store": 222,
	"./Dashboard/Store/": 222,
	"./Dashboard/Store/Restaurant": 162,
	"./Dashboard/Store/Restaurant/": 162,
	"./Dashboard/Store/Restaurant/index": 162,
	"./Dashboard/Store/Restaurant/index.js": 162,
	"./Dashboard/Store/SelfService": 123,
	"./Dashboard/Store/SelfService/": 123,
	"./Dashboard/Store/SelfService/index": 123,
	"./Dashboard/Store/SelfService/index.js": 123,
	"./Dashboard/Store/index": 222,
	"./Dashboard/Store/index.js": 222,
	"./Login": 117,
	"./Login/": 117,
	"./Login/ForgotMyPassword": 240,
	"./Login/ForgotMyPassword.js": 240,
	"./Login/ResetPassword": 242,
	"./Login/ResetPassword.js": 242,
	"./Login/SignIn": 241,
	"./Login/SignIn.js": 241,
	"./Login/SignUp": 239,
	"./Login/SignUp.js": 239,
	"./Login/index": 117,
	"./Login/index.js": 117,
	"./Menu": 223,
	"./Menu/": 223,
	"./Menu/Categories": 160,
	"./Menu/Categories/": 160,
	"./Menu/Categories/Edit": 398,
	"./Menu/Categories/Edit.js": 398,
	"./Menu/Categories/Move": 399,
	"./Menu/Categories/Move.js": 399,
	"./Menu/Categories/index": 160,
	"./Menu/Categories/index.js": 160,
	"./Menu/CouponGroups": 161,
	"./Menu/CouponGroups/": 161,
	"./Menu/CouponGroups/Edit": 400,
	"./Menu/CouponGroups/Edit.js": 400,
	"./Menu/CouponGroups/Move": 401,
	"./Menu/CouponGroups/Move.js": 401,
	"./Menu/CouponGroups/View": 402,
	"./Menu/CouponGroups/View.js": 402,
	"./Menu/CouponGroups/index": 161,
	"./Menu/CouponGroups/index.js": 161,
	"./Menu/Products/Edit": 403,
	"./Menu/Products/Edit.js": 403,
	"./Menu/index": 223,
	"./Menu/index.js": 223,
	"./Orders": 225,
	"./Orders/": 225,
	"./Orders/index": 225,
	"./Orders/index.js": 225,
	"./Payment/Customer": 226,
	"./Payment/Customer/": 226,
	"./Payment/Customer/PaymentApproveWaiting": 404,
	"./Payment/Customer/PaymentApproveWaiting.js": 404,
	"./Payment/Customer/PaymentSummary": 405,
	"./Payment/Customer/PaymentSummary.js": 405,
	"./Payment/Customer/index": 226,
	"./Payment/Customer/index.js": 226,
	"./Payment/Store": 227,
	"./Payment/Store/": 227,
	"./Payment/Store/index": 227,
	"./Payment/Store/index.js": 227,
	"./Profile/Company": 228,
	"./Profile/Company/": 228,
	"./Profile/Company/Profile": 244,
	"./Profile/Company/Profile.js": 244,
	"./Profile/Company/Stores": 245,
	"./Profile/Company/Stores.js": 245,
	"./Profile/Company/index": 228,
	"./Profile/Company/index.js": 228,
	"./Profile/Customer": 229,
	"./Profile/Customer/": 229,
	"./Profile/Customer/Companies": 246,
	"./Profile/Customer/Companies.js": 246,
	"./Profile/Customer/Edit": 406,
	"./Profile/Customer/Edit.js": 406,
	"./Profile/Customer/Invitations": 248,
	"./Profile/Customer/Invitations.js": 248,
	"./Profile/Customer/Profile": 251,
	"./Profile/Customer/Profile.js": 251,
	"./Profile/Customer/WorkPlaces": 247,
	"./Profile/Customer/WorkPlaces.js": 247,
	"./Profile/Customer/index": 229,
	"./Profile/Customer/index.js": 229,
	"./Profile/Store": 230,
	"./Profile/Store/": 230,
	"./Profile/Store/Collaborators": 250,
	"./Profile/Store/Collaborators.js": 250,
	"./Profile/Store/Profile": 249,
	"./Profile/Store/Profile.js": 249,
	"./Profile/Store/index": 230,
	"./Profile/Store/index.js": 230,
	"./Purchases/Company": 231,
	"./Purchases/Company/": 231,
	"./Purchases/Company/index": 231,
	"./Purchases/Company/index.js": 231,
	"./Purchases/Customer": 232,
	"./Purchases/Customer/": 232,
	"./Purchases/Customer/index": 232,
	"./Purchases/Customer/index.js": 232,
	"./Purchases/Store": 233,
	"./Purchases/Store/": 233,
	"./Purchases/Store/index": 233,
	"./Purchases/Store/index.js": 233,
	"./Search": 234,
	"./Search/": 234,
	"./Search/index": 234,
	"./Search/index.js": 234,
	"./Stores": 235,
	"./Stores/": 235,
	"./Stores/Edit": 407,
	"./Stores/Edit.js": 407,
	"./Stores/index": 235,
	"./Stores/index.js": 235,
	"./Tables": 236,
	"./Tables/": 236,
	"./Tables/Edit": 408,
	"./Tables/Edit.js": 408,
	"./Tables/Orders": 237,
	"./Tables/Orders/": 237,
	"./Tables/Orders/Edit": 409,
	"./Tables/Orders/Edit.js": 409,
	"./Tables/Orders/index": 237,
	"./Tables/Orders/index.js": 237,
	"./Tables/index": 236,
	"./Tables/index.js": 236,
	"./routes": 99,
	"./routes.js": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 531;